import { createLocale } from "react-localized";
import messages from "./messages/en.po";

const extra = {};

export default createLocale(messages, extra);
